import { createPersistedStore, storage } from '@connect-x-app/hybrid-utils';
import { EMPTY_WORKSTATION_STATE, WorkstationState } from '@connect-x-app/shared-domain-models';
import { createJSONStorage } from 'zustand/middleware';

type WorkstationStoreState = {
  setWorkstation: (workstation: WorkstationState | null) => void;
  workstation: WorkstationState | null;
};

export const useWorkstationStore = createPersistedStore<WorkstationStoreState>(
  (set, _) => ({
    setWorkstation: workstation => {
      set(_ => ({
        workstation,
      }));
    },
    workstation: EMPTY_WORKSTATION_STATE,
  }),
  {
    name: 'workstation-store',
    storage: createJSONStorage(() => storage),
  },
);
